import React from 'react';
import Checkbox from '../../common/Checkbox';
import PropTypes from 'prop-types';

export function ProductsFeedsTableHeader(props) {
  const { hasData, allSelected, onChangeSelectAll } = props;

  return (
    <thead>
      <tr>
        <th>
          <Checkbox
            value="select-all"
            checked={allSelected && hasData}
            hideLabel
            onChange={onChangeSelectAll}
            disabled={!hasData}
          />
        </th>
        <th>Process Name</th>
        <th>Started on</th>
        <th>Ended on</th>
        <th>New Products</th>
        <th>Updated Products</th>
        <th>Failed Products</th>
        <th>Success Rate</th>
        <th></th>
      </tr>
    </thead>
  );
}

ProductsFeedsTableHeader.propTypes = {
  hasData: PropTypes.bool.isRequired,
  allSelected: PropTypes.bool.isRequired,
  onChangeSelectAll: PropTypes.func.isRequired,
};
